import themeBase from "./themeBase";
import palette from "../palettes/defaultPalettes/deltaOne";

const factory = (p = palette, fontSizeCalculator) => {
  const base = themeBase(p);

  return {
    id: "deltaOne",
    label: "Delta One",
    main: {
      ...base.main,
      textTransform: "uppercase",
      fontSize: fontSizeCalculator(16),
      // display: "inline-block",
    },
    container: {
      ...base.container,
      // borderWidth: "1px 0px 1px 1px",
      // borderStyle: "solid",
      // borderColor: p.grid,
    },
    menu: {
      header: {
        wrapper: {
          ...base.menu.header.wrapper,
          // backgroundColor: p.primary,
          // textAlign: "left",
        },
        // preHeader: {
        //   width: "35px",
        //   border: `2px solid ${p.secondary}`,
        //   display: "inline-block",
        //   marginLeft: "20px",
        //   marginBottom: "11px",
        // },
        style: {
          ...base.menu.header.style,
          fontFamily: "Montserrat Bold", //TODO: import font
          fontSize: fontSizeCalculator(80),
          // letterSpacing: "2.8px",
          fontWeight: "bold",
          display: "inline-block",
          padding: "0px",
        },
      },
      table: {
        style: {
          ...base.menu.table.style,
          fontFamily: "Open Sans",
          borderCollapse: "unset",
        },
        header: {
          style: {
            ...base.menu.table.header.style,
            fontFamily: "Roboto",
            padding: "30px 15px 20px",
            borderWidth: "0px 0px 0px 0px",
            borderStyle: "solid",
            borderColor: p.grid,
            fontSize: fontSizeCalculator(50),
            fontWeight: "bold",
          },
          overrides: {
            ...base.menu.table.header.overrides,
            "0": {
              textAlign: "center",
            },
          },
        },
        data: {
          style: {
            ...base.menu.table.data.style,
            fontSize: fontSizeCalculator(30),
            fontFamily: "Roboto",
            fontWeight: "bold",
            borderWidth: "0px 0px 1px 0px",
            borderStyle: "solid",
            borderColor: p.grid,
            padding: "25px 15px",
          },
          overrides: {
            ...base.menu.table.data.overrides,
          },
        },
      },
    },
    specialSettings: {
      ...base.specialSettings,
    },
    advertisement: {
      ...base.advertisement,
    },
    content: {
      ...base.content,
    },
  };
};

export default factory;
